package songwritersnotebook.database

import kotlin.Long
import kotlin.String

public data class SongVersionEntity(
  public val id: String,
  public val ownerId: String,
  public val songId: String,
  public val timestamp: Long,
  public val versionNumber: Long,
  public val type: String,
  public val notes: String,
  public val data_: String,
)
